var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 389,
    height: 305,
    viewBox: "0 0 389 305",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(-313 -3541)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-2",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-3",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-4",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-5",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-6",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-7",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-8",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-9",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-10",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-11",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-12",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-13",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-14",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-15",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-16",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-17",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-18",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-19",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-20",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-21",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-22",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-23",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-24",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-25",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-26",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-27",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-28",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-29",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-30",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-31",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-32",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-33",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3541) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-34",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-35",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-36",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-37",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-38",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-39",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-40",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-41",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-42",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-43",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-44",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-45",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-46",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-47",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-48",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-49",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-50",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-51",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-52",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-53",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-54",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-55",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-56",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-57",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-58",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-59",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-60",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-61",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-62",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-63",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-64",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-65",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-66",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3553) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-67",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-68",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-69",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-70",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-71",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-72",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-73",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-74",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-75",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-76",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-77",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-78",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-79",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-80",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-81",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-82",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-83",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-84",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-85",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-86",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-87",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-88",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-89",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-90",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-91",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-92",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-93",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-94",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-95",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-96",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-97",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-98",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-99",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3565) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-100",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-101",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-102",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-103",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-104",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-105",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-106",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-107",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-108",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-109",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-110",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-111",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-112",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-113",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-114",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-115",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-116",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-117",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-118",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-119",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-120",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-121",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-122",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-123",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-124",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-125",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-126",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-127",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-128",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-129",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-130",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-131",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-132",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3577) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-133",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-134",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-135",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-136",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-137",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-138",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-139",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-140",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-141",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-142",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-143",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-144",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-145",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-146",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-147",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-148",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-149",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-150",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-151",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-152",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-153",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-154",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-155",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-156",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-157",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-158",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-159",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-160",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-161",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-162",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-163",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-164",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-165",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3589) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-166",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-167",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-168",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-169",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-170",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-171",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-172",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-173",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-174",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-175",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-176",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-177",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-178",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-179",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-180",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-181",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-182",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-183",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-184",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-185",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-186",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-187",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-188",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-189",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-190",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-191",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-192",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-193",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-194",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-195",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-196",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-197",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-198",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3601) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-199",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-200",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-201",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-202",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-203",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-204",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-205",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-206",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-207",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-208",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-209",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-210",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-211",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-212",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-213",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-214",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-215",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-216",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-217",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-218",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-219",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-220",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-221",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-222",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-223",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-224",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-225",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-226",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-227",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-228",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-229",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-230",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-231",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3613) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-232",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-233",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-234",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-235",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-236",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-237",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-238",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-239",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-240",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-241",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-242",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-243",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-244",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-245",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-246",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-247",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-248",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-249",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-250",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-251",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-252",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-253",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-254",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-255",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-256",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-257",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-258",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-259",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-260",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-261",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-262",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-263",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-264",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3625) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-265",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-266",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-267",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-268",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-269",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-270",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-271",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-272",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-273",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-274",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-275",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-276",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-277",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-278",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-279",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-280",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-281",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-282",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-283",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-284",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-285",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-286",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-287",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-288",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-289",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-290",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-291",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-292",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-293",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-294",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-295",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-296",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-297",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3637) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-298",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-299",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-300",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-301",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-302",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-303",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-304",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-305",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-306",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-307",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-308",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-309",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-310",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-311",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-312",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-313",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-314",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-315",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-316",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-317",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-318",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-319",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-320",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-321",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-322",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-323",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-324",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-325",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-326",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-327",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-328",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-329",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-330",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3649) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-331",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-332",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-333",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-334",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-335",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-336",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-337",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-338",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-339",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-340",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-341",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-342",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-343",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-344",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-345",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-346",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-347",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-348",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-349",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-350",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-351",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-352",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-353",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-354",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-355",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-356",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-357",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-358",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-359",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-360",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-361",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-362",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-363",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3661) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-364",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-365",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-366",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-367",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-368",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-369",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-370",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-371",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-372",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-373",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-374",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-375",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-376",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-377",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-378",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-379",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-380",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-381",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-382",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-383",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-384",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-385",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-386",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-387",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-388",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-389",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-390",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-391",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-392",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-393",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-394",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-395",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-396",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3673) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-397",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-398",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-399",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-400",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-401",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-402",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-403",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-404",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-405",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-406",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-407",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-408",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-409",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-410",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-411",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-412",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-413",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-414",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-415",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-416",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-417",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-418",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-419",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-420",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-421",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-422",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-423",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-424",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-425",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-426",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-427",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-428",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-429",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3685) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-430",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-431",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-432",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-433",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-434",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-435",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-436",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-437",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-438",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-439",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-440",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-441",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-442",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-443",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-444",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-445",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-446",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-447",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-448",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-449",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-450",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-451",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-452",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-453",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-454",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-455",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-456",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-457",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-458",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-459",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-460",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-461",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-462",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3697) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-463",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-464",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-465",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-466",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-467",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-468",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-469",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-470",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-471",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-472",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-473",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-474",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-475",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-476",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-477",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-478",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-479",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-480",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-481",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-482",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-483",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-484",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-485",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-486",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-487",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-488",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-489",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-490",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-491",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-492",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-493",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-494",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-495",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3709) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-496",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-497",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-498",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-499",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-500",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-501",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-502",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-503",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-504",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-505",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-506",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-507",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-508",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-509",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-510",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-511",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-512",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-513",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-514",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-515",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-516",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-517",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-518",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-519",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-520",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-521",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-522",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-523",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-524",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-525",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-526",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-527",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-528",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3721) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-529",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-530",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-531",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-532",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-533",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-534",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-535",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-536",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-537",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-538",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-539",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-540",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-541",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-542",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-543",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-544",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-545",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-546",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-547",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-548",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-549",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-550",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-551",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-552",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-553",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-554",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-555",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-556",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-557",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-558",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-559",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-560",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-561",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3733) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-562",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-563",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-564",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-565",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-566",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-567",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-568",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-569",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-570",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-571",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-572",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-573",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-574",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-575",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-576",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-577",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-578",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-579",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-580",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-581",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-582",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-583",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-584",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-585",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-586",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-587",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-588",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-589",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-590",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-591",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-592",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-593",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-594",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3745) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-595",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-596",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-597",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-598",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-599",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-600",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-601",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-602",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-603",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-604",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-605",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-606",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-607",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-608",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-609",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-610",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-611",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-612",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-613",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-614",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-615",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-616",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-617",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-618",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-619",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-620",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-621",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-622",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-623",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-624",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-625",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-626",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-627",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3757) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-628",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-629",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-630",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-631",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-632",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-633",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-634",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-635",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-636",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-637",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-638",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-639",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-640",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-641",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-642",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-643",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-644",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-645",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-646",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-647",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-648",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-649",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-650",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-651",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-652",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-653",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-654",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-655",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-656",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-657",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-658",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-659",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-660",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3769) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-661",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-662",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-663",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-664",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-665",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-666",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-667",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-668",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-669",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-670",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-671",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-672",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-673",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-674",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-675",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-676",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-677",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-678",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-679",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-680",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-681",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-682",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-683",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-684",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-685",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-686",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-687",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-688",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-689",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-690",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-691",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-692",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-693",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3781) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-694",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-695",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-696",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-697",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-698",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-699",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-700",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-701",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-702",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-703",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-704",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-705",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-706",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-707",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-708",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-709",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-710",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-711",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-712",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-713",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-714",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-715",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-716",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-717",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-718",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-719",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-720",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-721",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-722",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-723",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-724",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-725",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-726",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3793) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-727",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-728",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-729",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-730",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-731",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-732",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-733",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-734",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-735",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-736",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-737",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-738",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-739",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-740",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-741",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-742",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-743",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-744",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-745",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-746",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-747",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-748",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-749",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-750",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-751",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-752",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-753",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-754",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-755",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-756",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-757",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-758",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-759",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3805) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-760",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-761",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-762",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-763",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-764",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-765",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-766",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-767",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-768",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-769",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-770",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-771",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-772",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-773",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-774",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-775",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-776",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-777",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-778",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-779",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-780",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-781",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-782",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-783",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-784",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-785",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-786",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-787",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-788",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-789",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-790",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-791",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-792",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3817) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-793",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-794",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-795",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-796",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-797",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-798",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-799",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-800",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-801",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-802",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-803",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-804",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-805",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-806",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-807",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-808",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-809",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-810",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-811",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-812",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-813",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-814",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-815",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-816",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-817",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-818",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-819",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-820",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-821",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-822",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-823",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-824",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-825",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3829) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-826",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(318 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-827",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(330 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-828",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(342 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-829",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(354 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-830",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(366 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-831",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(378 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-832",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(390 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-833",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(402 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-834",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(414 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-835",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(426 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-836",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(438 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-837",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(450 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-838",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(462 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-839",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(474 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-840",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(486 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-841",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(498 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-842",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(510 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-843",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(522 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-844",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(534 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-845",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(546 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-846",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(558 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-847",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(570 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-848",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(582 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-849",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(594 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-850",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(606 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-851",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(618 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-852",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(630 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-853",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(642 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-854",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(654 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-855",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(666 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-856",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(678 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-857",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(690 3841) rotate(90)",
    fill: "#21afc8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58-858",
    "data-name": "Ellipse 58",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(702 3841) rotate(90)",
    fill: "#21afc8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDots);
export default __webpack_public_path__ + "static/media/dots.c74eca6f8dda1a4ef308125c85cfd8c0.svg";
export { ForwardRef as ReactComponent };